import { Component } from 'react'
import { useOnboardingStore } from '../stores/onboardingStore'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, prevChildType: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const childType = nextProps.children?.type ?? null
    if (childType !== prevState.prevChildType) {
      return { hasError: false, error: null, prevChildType: childType }
    }
    return null
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info)
  }

  handleBack = () => {
    useOnboardingStore.getState().prevStep()
  }

  handleReset = () => {
    useOnboardingStore.getState().reset()
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) return this.props.children

    const { error } = this.state
    return (
      <div
        style={{
          minHeight: '60vh',
          background: '#ffffff',
          color: '#1a1a1a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '48px 24px',
        }}
      >
        <div style={{ maxWidth: 560, width: '100%' }}>
          <h1
            style={{
              fontFamily:
                'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
              fontWeight: 200,
              fontSize: 36,
              lineHeight: 1.15,
              margin: '0 0 16px',
              color: '#1a1a1a',
            }}
          >
            Something went wrong on this step.
          </h1>
          <p
            style={{
              fontFamily:
                'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
              fontSize: 15,
              lineHeight: 1.6,
              color: 'rgba(0,0,0,0.72)',
              margin: '0 0 28px',
            }}
          >
            Your form data is saved. This step hit an error while rendering —
            you can go back a step and try again, or reset the form to start
            fresh.
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={this.handleBack}
              style={{
                background: '#45BDA6',
                color: '#0a0a0a',
                border: 'none',
                borderRadius: 8,
                padding: '12px 20px',
                fontFamily: 'Inter, sans-serif',
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              Go back a step
            </button>
            <button
              type="button"
              onClick={this.handleReset}
              style={{
                background: 'transparent',
                color: '#1a1a1a',
                border: '1px solid rgba(0,0,0,0.24)',
                borderRadius: 8,
                padding: '12px 20px',
                fontFamily: 'Inter, sans-serif',
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              Reset form
            </button>
          </div>
          <details
            style={{
              marginTop: 32,
              fontFamily: 'Inter, sans-serif',
              fontSize: 12,
              color: 'rgba(0,0,0,0.48)',
            }}
          >
            <summary style={{ cursor: 'pointer', userSelect: 'none' }}>
              Error details
            </summary>
            <pre
              style={{
                marginTop: 12,
                padding: 12,
                background: 'rgba(0,0,0,0.04)',
                border: '1px solid rgba(0,0,0,0.08)',
                borderRadius: 6,
                overflowX: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                color: 'rgba(0,0,0,0.72)',
              }}
            >
              {error?.message || String(error)}
            </pre>
          </details>
        </div>
      </div>
    )
  }
}
